import React from 'react';
import { Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { CoverBanner } from '../Common/CoverItem';
import { useQuery } from 'react-query';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';


import productBanner from '../assets_2026/homepage_top_banner_img.png';
import coreCollectionBtn from '../assets_2026/home_core_collection_btn.png';
import jmlLibraryBtn from '../assets_2026/home_jml_library_btn.png';
import seasonalCollectionBtn from '../assets_2026/home_seasonal_collection_btn.png';
import brandLibraryBtn from '../assets_2026/home_brand_library_btn.png';
import FadeIn from 'react-fade-in';
import CircularProgress from '@mui/material/CircularProgress';
import * as api from '../Api/fabricApi.js';

import ProductThumbnail from '../Common/ProductThumbnail';
import { EmptyState } from '../Common/EmptyState';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useHistory } from "react-router-dom";


// import withWidth, { isWidthUp } from '@mui/material/withWidth';
import baseStyles from '../Common/styles';

const useStyles = makeStyles((theme) => ({
    ...baseStyles(theme),
    sectionHeader: {
        margin: '30px auto',
        width: '100%',
    },
    hr: {
        height: '5px',
        width: "45px",
        backgroundColor: theme.palette.primary.main,
        margin: '10px auto 10px',
    },
    navGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '4px',
        marginTop: '7px',
    },
    navCard: {
        position: 'relative',
        display: 'block',
        overflow: 'hidden',
    },
    navCardImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
        transition: 'transform 0.3s ease',
        '$navCard:hover &': {
            transform: 'scale(1.08)',
        },
    },
    navCardOverlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '0 16px',
        color: '#fff',
        textTransform: 'uppercase',
        letterSpacing: '0.02em',
        fontSize: '4rem',
        textShadow: '0 2px 6px rgba(0,0,0,0.55)',
        pointerEvents: 'none',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.05rem',
        },
    },
    navCardOverlayBold: {
        fontWeight: 700,
    },
    navCardOverlayLight: {
        fontWeight: 400,
        marginLeft: '0.35em',
    },
    featuredItems: {
        marginTop: '20px'
    },
    gridList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    aside: {
        margin: '20px auto',
    },
    sectionTitle: {
        margin: 'auto',
        zindex: 2
    },
    '@media (max-width: 1366px)': {
        navCardOverlay: {
            fontSize: '3rem'
        }
    },
    '@media (max-width: 768px)': {
        navCardOverlay: {
            fontSize: '2.5rem'
        }
    },
}));

const useFeaturedItemStyles = makeStyles((theme) => ({
    itemDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        textAlign: 'left',
        margin: '7px 0 7px'
    }
}));
const FeaturedItem = ({ item }) => {
    const classes = useFeaturedItemStyles();
    return (
        <div>
            <Link color="inherit" component={RouterLink} to={
                {
                    pathname: "/fabric-library/" + item.fileName,
                    state: { fabricDetails: item }
                }
            }>
                <ProductThumbnail image={item.url} height="250" width="250" />
                <div className={classes.itemDetails}>
                    <Typography variant="subtitle2" color="primary">{item.productCategory}</Typography>
                    <Typography variant="body1" >{item.brandItemCode}</Typography>
                </div>
            </Link>
        </div>
    );
};

const getFeaturedItems = (items) => {
    return items.slice(0, 5).map(item => { // TODO what if there are fewer than 5 returned?
        return <ImageListItem style={{ height: "100%" }} key={item.name}><FeaturedItem item={item} /></ImageListItem>;
    });
};

const Landing = (props) => {
    const classes = useStyles();
    let history = useHistory();

    // TODO supposed to load mybrand 
    const { isLoading, error, data } = useQuery(['myBrand', null, null], ({ queryKey }) => api.getFabrics(queryKey[0], queryKey[1], queryKey[2]));

    return (
        <FadeIn>
            <div className={classes.root}>
                <CoverBanner image={productBanner}
                    query={{ collection1: '2027 Collections' }}
                />

                <div className={classes.navGrid}>
                    <Link component={RouterLink} to="/jml-collection" className={classes.navCard}>
                        <img src={coreCollectionBtn} alt="Core Collection" className={classes.navCardImage} />
                        <div className={classes.navCardOverlay}>
                            <span><span className={classes.navCardOverlayBold}>Core</span> Collection</span>
                        </div>
                    </Link>
                    <Link component={RouterLink} to="/jml-library" className={classes.navCard}>
                        <img src={jmlLibraryBtn} alt="JML Library" className={classes.navCardImage} />
                        <div className={classes.navCardOverlay}>
                            <span><span className={classes.navCardOverlayBold}>JML</span> Library</span>
                        </div>
                    </Link>
                    <Link component={RouterLink} to="/seasonal-collection" className={classes.navCard}>
                        <img src={seasonalCollectionBtn} alt="Seasonal Collection" className={classes.navCardImage} />
                        <div className={classes.navCardOverlay}>
                            <span><span className={classes.navCardOverlayBold}>Seasonal</span> Collection</span>
                        </div>
                    </Link>
                    <Link component={RouterLink} to="/brand-library" className={classes.navCard}>
                        <img src={brandLibraryBtn} alt="Brand Library" className={classes.navCardImage} />
                        <div className={classes.navCardOverlay}>
                            <span><span className={classes.navCardOverlayBold}>Brand</span> Library</span>
                        </div>
                    </Link>
                </div>
                <div className={classes.section}>
                    <Button
                        onClick={() => history.push({ pathname: '/brand-library' })}
                        className={classes.sectionHeader}
                        color="primary"
                        disableRipple>
                        <div>
                            <Typography variant="header" color="primary">Your Brand Library
                            </Typography>
                            <div className={classes.hr}></div>
                        </div>
                    </Button>

                    {error && <EmptyState />}
                    {isLoading && !error && <div className={classes.circularProgress}><CircularProgress /></div>}
                    {!error && !isLoading && data?.fabrics && data.fabrics.length === 0 ? <EmptyState />
                        : !isLoading && !error && <FadeIn>
                            <ImageList variant="quilted" className={classes.gridList} cols={5} gap={10}>
                                {getFeaturedItems(data.fabrics)}
                            </ImageList>
                            <Button
                                className={classes.aside}
                                onClick={() => history.push({ pathname: '/brand-library' })}
                                color="primary"
                                disableRipple
                            // startIcon={<ArrowBackIosIcon fontSize="small"/>}
                            >View All</Button>
                        </FadeIn>}


                </div>
            </div>
        </FadeIn>
    );
};

export default Landing;